import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { NikeApp } from '@nike/nike-design-system-icons'
import { NavItem, setActiveValueInNavItems, VerticalNavbar } from '@nike/eds'
import { UserPermissions } from '../../UserAccessManagement/UserRoles'

export function SideBar({ userPermissions }: { userPermissions: UserPermissions }) {
    const navigate = useNavigate()
    const location = useLocation()
    const routingMap = new Map<string, string>([
        ['1', '/dashboard'],
        ['2', '/inventory-overview'],
        ['3', '/simulation/raw-event'],
        ['4', '/flow-overview'],
        ['5', '/trigger'],
        ['6', '/entry-context-overview'],
        ['7', '/imbalance-management'],
    ])

    const getInitialItems = () => {
        const baseItems: NavItem[] = [
            {
                id: '1',
                icon: 'Report',
                label: 'Dashboard',
                active: false,
            },
        ]

        baseItems.push({
            id: '2',
            icon: 'Journal',
            label: 'Inventory overview',
            active: false,
        })

        if (userPermissions.canSimulateEvents) {
            baseItems.push({
                id: '3',
                icon: 'Play',
                label: 'Simulate',
                active: false,
            })
        }

        baseItems.push({
            id: '4',
            icon: 'Activity',
            label: 'Flow overview',
            active: false,
        })

        if (userPermissions.canTriggerUKDivert || userPermissions.canTriggerBondedReturn || userPermissions.canTriggerDSLeftCW || userPermissions.canTriggerManualClearing) {
            baseItems.push({
                id: '5',
                icon: 'ClassWorkout',
                label: 'Trigger',
                active: false,
            })
        }

        if (userPermissions.canViewEntryContext) {
            baseItems.push({
                id: '6',
                icon: 'Edit',
                label: 'Entry context corrections',
                active: false,
            })
        }

        baseItems.push({
            id: '7',
            icon: 'Transfers',
            label: 'Imbalance management',
            active: false,
        })

        return baseItems
    }

    const [items, setItems] = useState<NavItem[]>(getInitialItems())

    const handleClick = (item: { id: string }) => {
        navigate(routingMap.get(item.id))
    }

    useEffect(() => {
        setItems(getInitialItems())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPermissions])

    useEffect(() => {
        changeIconBasedOnLocation()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items, location])

    const changeIconBasedOnLocation = () => {
        for (const item of items) {
            const route = routingMap.get(item.id)
            if (location.pathname.includes(route)) {
                if (!item.active) {
                    setActiveIcon(item.id)
                }
            }
        }
    }

    const setActiveIcon = (id: string) => {
        const newItems = setActiveValueInNavItems(id, items)
        if (newItems) {
            setItems(newItems as NavItem[])
        }
    }

    return (
        <VerticalNavbar
            appName={'Customs Inventory'}
            items={items}
            navLogoSlot={
                <Link reloadDocument to="/" aria-label="logo-link">
                    <NikeApp title="Nike logo" color={'white'} width={'56px'} height={'64px'} style={{ marginTop: '6px' }} />
                </Link>
            }
            onNavigate={handleClick}
        />
    )
}
